module.exports = __webpack_public_path__ + "img/银联.8d6b92d5.png";